module.exports = __webpack_public_path__ + "img/coupon2022f2-sp.0a989aef.jpg";